import { Changelog, ChangelogNotification } from "@common/models/Changelog.model";
import ApiService from "@common/services/Api.service";
import { AxiosResponse } from "axios";

export class FeaturesService {
  private apiService: ApiService;

  constructor() {
    this.apiService = ApiService.getInstance();
  }

  getChangeLogs(
    sort: "latest" | "priority" = "latest",
    abortSignal?: AbortSignal,
  ): Promise<AxiosResponse<Changelog[]>> {
    return this.apiService.get({
      resource: `misc/changelogs?return_all=true&sort=${sort}`,
      config: {
        signal: abortSignal,
      },
    });
  }

  getChangeLogsNotifications(abortSignal?: AbortSignal): Promise<AxiosResponse<ChangelogNotification[]>> {
    return this.apiService.get({
      resource: `misc/changelog_notification`,
      config: {
        signal: abortSignal,
      },
    });
  }

  markNotificationAsRead(changelogId: string) {
    return this.apiService.delete({
      resource: `/misc/changelog_notification/${changelogId}/read`,
    });
  }
}
